import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ButtonList, Column, DropdownButton, DropdownButtonContext, FlexBox, Icon, IconButton, InputText, Text, } from '@dixa/lib-shared-habla';
import { useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDebounce } from 'react-use';
import { analytics } from 'app/utils/segment';
import { actions as companyModalActions } from 'components/shared/companyModal/actions/companyModal';
import { userModalActions } from 'components/usersModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
import styles from './contactsSidebarTop.module.scss';
const categories = [
    {
        type: 'enduser',
        routePath: 'user',
        dropdownLabel: 'Contacts',
    },
    {
        type: 'company',
        routePath: 'company',
        dropdownLabel: 'Companies',
    },
];
export function ContactsSidebarTop() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const currentCategory = categories.find(({ routePath }) => pathname.includes(routePath));
    const dispatch = useAppDispatch();
    const { params: { q: searchTerm = '' }, setParam, } = useAppSearchParams('/contacts/user/:id');
    const searchInputRef = useRef(null);
    const [searchValue, setSearchValue] = useState(searchTerm);
    useDebounce(() => setParam('q', searchValue), 300, [searchValue]);
    const getEntityType = () => {
        if ((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.type) === 'enduser') {
            return 'contact';
        }
        if ((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.type) === 'company') {
            return 'company';
        }
        return '';
    };
    const dropdownButtons = (dropdownProps) => {
        const handleItemClick = (path, type) => {
            const navigateTo = `/contacts/${path}`;
            if (pathname.includes(navigateTo)) {
                dropdownProps.closeDropdown();
                return;
            }
            if (type === 'enduser') {
                analytics.contactsViewEndUsers();
            }
            else if (type === 'company') {
                analytics.contactsViewCompanies();
            }
            dropdownProps.closeDropdown();
            setSearchValue('');
            navigate(navigateTo);
        };
        return categories.map(({ type, dropdownLabel, routePath }) => (_jsx(ButtonList.Item, Object.assign({ isSelected: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.type) === type, onClick: () => handleItemClick(routePath, type) }, { children: dropdownLabel }), type)));
    };
    const handleSearchInputFocus = () => {
        analytics.contactsSearchFocused();
    };
    const handleSearchInputBlur = () => {
        analytics.contactsSearchBlurred();
    };
    const handleAddClick = () => {
        if ((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.type) === 'enduser') {
            analytics.contactsAddNewContactClicked();
            dispatch(userModalActions.show({ user: { roles: ['enduser'] } }));
        }
        else if ((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.type) === 'company') {
            analytics.contactsAddNewCompanyClicked();
            dispatch(companyModalActions.companyModalShow());
        }
    };
    const handleSearchSubmit = (event) => {
        setSearchValue(event.target.value);
    };
    const handleClearSearch = () => {
        var _a;
        setSearchValue('');
        setParam('q', '');
        (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Column.Row, Object.assign({ slottable: true, borderBottom: true }, { children: [_jsx(Column.Slot, { children: _jsx(DropdownButton, Object.assign({ noStyle: true, buttonProps: { variant: 'tertiary' }, dropdownProps: { closeOnBlur: true }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: (dropdownProps) => (_jsx(ButtonList, { children: dropdownButtons(dropdownProps) })) }) }, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [_jsx(Text.Heading, Object.assign({ as: "h1" }, { children: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.dropdownLabel })), _jsx(Icon, { className: styles.dropdownIcon, name: "angle-down" })] })) })) }), _jsx(Column.Slot, Object.assign({ noVerticalPadding: true, placement: "end" }, { children: _jsxs(Button, Object.assign({ slotStart: _jsx(Icon, { name: "plus" }), variant: "secondary", onClick: handleAddClick, "data-testid": "contacts-add-button" }, { children: ["Add ", getEntityType()] })) }))] })), _jsx(Column.Row, { children: _jsx(InputText, { ref: searchInputRef, value: searchValue, onChange: handleSearchSubmit, placeholder: "Search...", onFocus: handleSearchInputFocus, onBlur: handleSearchInputBlur, disabled: !currentCategory, suffix: {
                        type: 'custom',
                        value: (_jsx(FlexBox, Object.assign({ alignItems: "center", padding: "0 100" }, { children: _jsx(IconButton, { variant: "tertiary", disabled: !searchValue, icon: searchValue ? 'close' : 'search', onClick: searchValue ? handleClearSearch : undefined }) }))),
                        noWrap: true,
                    } }) })] }));
}
